// Score distribution histogram — bucket agents by their average score.
// Uses data already loaded into state.qaCopilot — no new fetch.
import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { CHART } from '@/components/charts/chartPalette'
import { ChartWidgetCard, axisTooltip } from './chartWidget'

const BUCKETS = [
  { label: '<60', min: 0, max: 60, color: 'CRITICAL' },
  { label: '60–70', min: 60, max: 70, color: 'CAUTION' },
  { label: '70–80', min: 70, max: 80, color: 'WARNING' },
  { label: '80–90', min: 80, max: 90, color: 'SUCCESS_HOVER' },
  { label: '90+', min: 90, max: 101, color: 'SUCCESS' },
]

export const ScoreDistributionWidget = () => {
  const agents = useSelector(
    (state) => state.qaCopilot.data.reportingByUser.aggregate_scores_by_user
  )
  const loading = useSelector((state) => state.qaCopilot.loading.reportingByUser)

  const option = useMemo(() => {
    const counts = BUCKETS.map((bucket) => ({
      ...bucket,
      color: CHART[bucket.color],
      count: (agents || []).filter((agent) => {
        const score = parseFloat(agent.average_score)
        return score >= bucket.min && score < bucket.max
      }).length,
    }))
    return {
      tooltip: axisTooltip((params) => {
        const point = params[0]
        const agentCount = point?.value || 0
        return `${point?.axisValue}<br/>${agentCount} agent${agentCount === 1 ? '' : 's'}`
      }),
      grid: { left: 40, right: 16, top: 24, bottom: 32 },
      xAxis: { type: 'category', data: counts.map((bucket) => bucket.label) },
      yAxis: { type: 'value', name: 'Agents' },
      series: [
        {
          type: 'bar',
          data: counts.map((bucket) => ({
            value: bucket.count,
            itemStyle: { color: bucket.color },
          })),
          barWidth: '60%',
        },
      ],
    }
  }, [agents])

  return (
    <ChartWidgetCard
      title="Agents by Average Score"
      info="How many agents fall into each average-score band, so you can see the spread of performance across the team."
      loading={loading}
      option={option}
      height="260px"
    />
  )
}
